import { createAction } from '@ngrx/store';

/**
 * Set patient form values
 */
export const setRapidRecoPatientFormValues = createAction('[Rapid Reco] Set Patient Form Values');
/**
 * Update allowance
 */
export const updateRapidRecoAllowance = createAction('[Rapid Reco] Update allowance');
/**
 * Reset allowance
 */
export const resetRapidRecoAllowance = createAction('[Rapid Reco] Reset allowance');
